import {CurrencyFormat, formatCurrency} from '@product-web/locale/currency'

export const toStringNoDecimal = (amount: number | undefined, currency: string): string =>
    formatCurrency(amount, currency, {format: CurrencyFormat.FixedFractionDigits(0)})
